'use strict';

const SELECTORS = {
    body: 'body',
    dropdownMenu: '.dropdown-toggle',
    searchToggleBtn: '.js-search-toggle-btn',
};

function closeDropDown() {
    $(SELECTORS.dropdownMenu).attr('aria-expanded', false);
    $(SELECTORS.dropdownMenu).siblings('.dropdown-menu').removeClass('show');
    $(SELECTORS.dropdownMenu).parent().removeClass('show');
}

function toggleDropdown($button) {
    const expanded = $button.attr('aria-expanded') === 'true';

    if (!expanded) {
        // close other expanded menu first.
        closeDropDown();
    }

    $button.attr('aria-expanded', !expanded);
    $button.siblings('.dropdown-menu').toggleClass('show');
    $button.parent().toggleClass('show');
}

/**
 * Accessibility function for dropdown menu.
 */
function initMenu() {
    $(SELECTORS.body).on('click keydown focus', SELECTORS.dropdownMenu, function(event) {
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleDropdown($(this));
        }
    });

    if (window.innerWidth < 1024) {
        $('body').on('click', '.dropdown-toggle', function() {
                $(this).parent().addClass('show');
        });
    }
}

/**
 * Toggle aria-expanded.
 * @param {*} $elem
 */
function toggleAriaExpanded($elem) {
    $elem.attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
    });
}

/**
 * Accessibility function for header search.
 */
function iniHeaderSearch() {
    $(SELECTORS.body).on('click keydown', SELECTORS.searchToggleBtn, function () {
        toggleAriaExpanded($(SELECTORS.searchToggleBtn));
    });

}

/**
 * Announce a message to screen readers via the page-level ARIA live regions.
 * Requires #a11y-status (polite) and #a11y-alert (assertive) to exist in the DOM.
 * @param {string} message - Text to announce
 * @param {string} [priority='polite'] - 'polite' or 'assertive'
 */
function announceToSR(message, priority) {
    var regionId = priority === 'assertive' ? 'a11y-alert' : 'a11y-status';
    var region = document.getElementById(regionId);
    if (!region) return;
    // Clear first so repeated identical messages still trigger a re-announcement
    region.textContent = '';
    setTimeout(function () {
        region.textContent = message;
    }, 50);
}

module.exports = {
    init: function() {
        initMenu();
        iniHeaderSearch();
    },
    announceToSR: announceToSR
};
